import ChineseResidentIDHelper from '../../helpers/ChineseResidentIDHelper';
import CheckoutOverlay from '../CheckoutOverlay';

function ChineseResidentIDOverlay() {
  return (
    <CheckoutOverlay
      popup
      title="deliveryOptions.resident.id.chinese.title"
    >
      <ChineseResidentIDHelper />
    </CheckoutOverlay>
  );
}

export default ChineseResidentIDOverlay;
